import { render } from "./inscriptStat.vue?vue&type=template&id=3457d4b8&scoped=true"
import script from "./inscriptStat.vue?vue&type=script&lang=js"
export * from "./inscriptStat.vue?vue&type=script&lang=js"

import "./inscriptStat.vue?vue&type=style&index=0&id=3457d4b8&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3457d4b8"]])

export default __exports__